import type { AppEnv } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

const rxCardsComLinkRegex = /^(www\.)?(qa\.)?rxcards\.healthcare\.com/;

export function isRxCardsComLink(url: URL) {
  return rxCardsComLinkRegex.test(url.hostname);
}

const hostnameMap: Record<AppEnv, string> = {
  local: 'qa.rxcards.healthcare.com',
  dev: 'qa.rxcards.healthcare.com',
  qa: 'qa.rxcards.healthcare.com',
  stg: 'qa.rxcards.healthcare.com',
  prd: 'rxcards.healthcare.com',
};

export function checkRxCardsComLink(url: URL): string {
  const config = getClientApplicationConfig();
  // eslint-disable-next-line no-param-reassign
  url.hostname = hostnameMap[config.core.appEnvironment];
  return decodeURIComponent(url.href);
}
